import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMenselijk = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M20.49 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M20.46 18a6 6 0 0 1 6 6v10h-12V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.16 12.174a3.31 3.31 0 0 0 6.61 0l1 .052a4.31 4.31 0 0 1-8.61 0z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M22.53 22.14a2.23 2.23 0 0 0-2 1.36 2.21 2.21 0 0 0-2-1.36A2.6 2.6 0 0 0 16 24.79c0 2 4.47 5.07 4.47 5.07S25 26.8 25 24.79a2.6 2.6 0 0 0-2.47-2.65"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMenselijk);

export default ForwardRef;
